<template>
  <!-- https://www.rhenopalatia.com/%C3%BCber-uns/faq/ -->
  <!-- https://albertina.de/faq -->

  <!-- https://bootstrap-vue.js.org/docs/components/collapse -->

  <div role="tablist" style="margin-top: 3rem;">

  <!-- https://unsplash.com/photos/yjePAp-tpmQ -->
    <div>
      <b-img src="/public/downloads/directories/images/searching_faq.jpg" fluid alt="FAQ"></b-img>
    </div>
    <br/>
    <br/>
    <p>
    Hier sollen einige Fragen geklärt werden, die sich uns immer wieder aufs Neue stellen.
    </p>
    <br/>
    <br/>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-1 variant="success">Wie muss der Kranz für den Gräbergang aussehen?</b-button>
      </b-card-header>
      <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            <ul style="display: inline-block; text-align: left">
              <li>Wo wird der Kranz bestellt?: <b-link href="https://www.blumen-walter-bruchsal.de/" target="_blank">Friedhofsgärtnerei Walter</b-link></li>
              <li>Was kommt auf die Schleifen?:
                <ul>
                  <li>In ewigem Gedenken</li>
                  <li>PV Bund 1895 zu Bruchsal</li>
                </ul>
              </li>
              <li>Wie viel kostet der Kranz in etwa?: ca. 150 Euro</li>
            </ul>
            <div>
              <b-img src="/public/downloads/directories/images/Kranz.jpeg" fluid alt="Kranz"></b-img>
            </div>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-2 variant="success">Woher bekomme ich die aktuelle Adressenliste?</b-button>
      </b-card-header>
      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            <b>Vor jedem</b> Versenden von PV-Post (Semesterprogramm, Einladungen etc.) bitte unseren Adresswart
            Bbr. Max Wenzel nach der aktuellen Mitgleiderliste anfragen.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-3 variant="success">Wie erstelle ich einen Serienbrief?</b-button>
      </b-card-header>
      <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            <b>Vor jedem</b> Versenden von PV-Post (Semesterprogramm, Einladungen etc.) bitte unseren Adresswart
            Bbr. Max Wenzel nach der aktuellen Mitgleiderliste anfragen.
            Außerdem findest Du eine Wordvorlage mit Wappen im Downlaodbereich.
            <b-link href="https://office-lernen.com/serienbrieferstellung/" target="_blank">Hier</b-link> findest Du eine gute Anleitung, wie
            man einen Serienbrief in Word erstellen kann.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-4 variant="success">Wie binde ich eine Krawatte?</b-button>
      </b-card-header>
      <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
        <b-card
            header="Doppelter Windsor"
            bg-variant="light"
            img-src="/public/downloads/directories/images/DoppelterWindsor.png"
            img-alt="Doppelter Windsor"
            img-top
            tag="article"
            style=""
            class="text-justify"
        >
          <b-card-text>
            Der wahrscheinlich beliebtesten Krawattenknoten der Welt vor: Der doppelte Windsor.
            Auch bekannt als Windsor.
            Ein breiter, eleganter und symmetrischer Krawattenknoten, den Du auf jeden Fall beherrschen sollten.
          </b-card-text>
        </b-card>
        <b-card
            header="Einfacher Windsor"
            bg-variant="light"
            img-src="/public/downloads/directories/images/EinfacherWindsor.png"
            img-alt="Einfacher Windsor"
            img-top
            tag="article"
            style=""
            class="text-justify"
        >
          <b-card-text>
            Der einfache Windsor (auch bekannt als halber Windsor oder einfacher Knoten) ist einer der bekanntesten Krawattenknoten der Welt.
            Qua Größe liegt der halbe Windsor zwischen dem etwas dünneren Four in Hand und seinem großen Bruder, genannt doppelter Windsor.
            Die Bezeichnung halber Windsor lässt vermuten, dass die Größe des Krawattenknoten genau die Hälfte ist.
            Dies ist jedoch nicht der Fall.
            Der einfache Windsor Knoten ist ungefähr ein Viertel kleiner.
          </b-card-text>
        </b-card>
        <b-card
            header="Four in Hand"
            bg-variant="light"
            img-src="/public/downloads/directories/images/FourInHand.png"
            img-alt="Four in Hand"
            img-top
            tag="article"
            style=""
            class="text-justify"
        >
          <b-card-text>
            Der ideale Basis Knoten, den jeder beherrschen sollte, wenn es ums Krawatte binden geht.
            Dieser Krawattenknoten ist einer der einfachsten Knoten und eignet sich besonders für die Anfänger unter uns.
            Der Four in Hand Knoten ist ein eleganter Krawattenknoten, den Sie zu sehr vielen Anlässen tragen können.
            Dieser Krawattenknoten sollte zu Deinem Standard Repertoire gehören.
          </b-card-text>
        </b-card>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-5 variant="success">Wo bestelle ich Couleurartikel?</b-button>
      </b-card-header>
      <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            Grundsätzlich unterstützt Dich dabei unser Couleurwart. Viele Bestellungen (Mützen, Pekeschen etc.) bestellt unser Bbr. Frank Schreck.
            Kleinere Artikel wie Wein- und Bierzipfel kannst Du bei <b-link href="http://www.couleur.at/index.asp" target="_blank">Bitter Couleur</b-link>
            bestellen.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-6 variant="success">Wo kann ich meine Bilder der letzten Veranstaltung hochladen?</b-button>
      </b-card-header>
      <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            Du hast Glück: Du kannst sie hier auf der Homepage im Upload-Bereich direkt von Deinem Handy hochladen. Alternativ kannst Du sie auch von der Kamera oder
            dem Handy auf Deinen Rechner ziehen und von dort aus hochladen. Gerne unterstützen Dich dabei auch unsere technikaffinen Füxe.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-7 variant="success">Was sind die Farben der PV Bund?</b-button>
      </b-card-header>
      <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            <ul style="display: inline-block; text-align: left">
              <li>#ff3300 RGB (255, 51, 0) (<font color="#ff3300">rot</font>)</li>
              <li>#c0c0c0 RGB (192, 192, 192) (<font color="#c0c0c0">silber</font>)</li>
              <li>#3399ff RGB (51, 153, 255) (<font color="#3399ff">hellblau</font>)</li>
            </ul>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-8 variant="success">Wie lautet die Bankverbindung der Aktivitas?</b-button>
      </b-card-header>
      <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            Sparkasse Kraichgau Bruchsal-Bretten-Sinsheim <br/>
            Bernd Braunbarth <br/>
            BIC BRUSDE66 <br/>
            IBAN DE 34 6635 0036 0010 6890 00 <br/>
            Bankleitzahl: 663 500 36 <br/>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-9 variant="success">Wie lautet die Bankverbindung der AH-Kasse?</b-button>
      </b-card-header>
      <b-collapse id="accordion-9" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            Postbank Ndl der Deutsche Bank<br/>
            Altherrenschaft PV Bund<br/>
            BIC PBNKDEFF<br/>
            IBAN DE98 6601 0075 0020 7007 58<br/>
            Bankleitzahl 660 100 75<br/>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-10 variant="success">Wie bestelle ich neue Mützen?</b-button>
      </b-card-header>
      <b-collapse id="accordion-10" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            <ul style="display: inline-block; text-align: left">
              <li>Zumindest alle Inaktiven und Aktiven, vor allem die Füxe abfragen, wer eine Mütze benötigt</li>
              <li>Für die Mützengröße wird der Kopfumfang in cm benötigt</li>
              <li>Die Kosten für die erste Mütze (Füxe) übernimmt die Verbindung, die Kosten für eine Mütze liegen bei ca. 80 Euro.</li>
            </ul>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-11 variant="success">Wo lassen wir das Semesterprogramm drucken?</b-button>
      </b-card-header>
      <b-collapse id="accordion-11" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            <ul style="display: inline-block; text-align: left">
              <li>Wo lassen wir das Semesterprogramm drucken?: <b-link href="https://www.mediachefs.de/" target="_blank">mediachefs</b-link></li>
              <li>Wer ist unser Ansprechpartner?: <b-link href="mailto::benz@mediachefs.de" target="_blank">Herr Benz</b-link></li>
              <li>In welcher Stückzahl lassen wir drucken?:ca. 200 Stück</li>
              <li>Wie viel kostet uns der Druck?: ca. 80 Euro</li>
            </ul>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-12 variant="success">Wie bestelle ich neue Kommersbücher?</b-button>
      </b-card-header>
      <b-collapse id="accordion-12" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            Kommersbücher werden, wenn überhaupt, über Bbr. Bernd Braunbarth bestellt, da er ganz andere Rabatte bekommt.
            Ein Kommersprügel kostet etwa 70 Euro.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-13 variant="success">Was muss bei der Erstellung eines Semesterprogramms beachtet werden?</b-button>
      </b-card-header>
      <b-collapse id="accordion-13" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            <ul style="display: inline-block; text-align: left">
              <li>Spätestens mit der Abschlusskneipe beginnt die Planung des nächsten Semesters</li>
              <li>Alle Termine müssen mit dem AH Senior und den Chargen der Aktivitas abgestimmt werden.</li>
              <li>Alle Termine müssen mit den jeweiligen Besitzern der Lokalitäten abgestimmt und reserviert werden (Belvedere, Linde,...).</li>
              <li>Bbr. Max Fank ist rechtzeitig zu informieren, damit er sich das Layout einplanen kann</li>
              <li>Gedruckt und frankiert werden die Briefe wechselweise bei Bbr. Manuel Debatin bzw. Bbr. Frank Schreck.</li>
              <li>Die aktuelle Adressliste ist von Bbr. Max Wenzel zu erfragen.</li>
              <li>Die schriftliche Einladung mit dem Semesterprogramm sollte spätestens 1 Woche vor der Antrittskneipe verschickt werden.</li>
            </ul>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        text: `
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
          richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
          brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
          tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
          assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
          wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
          vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
          synth nesciunt you probably haven't heard of them accusamus labore VHS.
        `
      }
    }
  }
</script>